const en = {
  global: {
    see_more: 'See more',
    last_news: 'Last News',
    view_all: 'View All',
    search: 'Search',
    title: 'National Qualifications System',
    description:
      'Service responsible for promoting, developing and integrating technical and vocational training offers through the National Qualifications Catalog, enabling the assessment and certification of professional skills.',
    no_data_found: 'No data found',
    go_back: 'Go Back',
  },
  metadata: {
    home_title: 'Home Title',
    home_description: 'Home description',
  },

  navigation: {
    home: 'Home',
    ucsnq: 'UCSNQ',
    snq: 'SNQ',
    snq_component: 'SNQ Component',
    catalog: 'Catalog',
    equivalency: 'Equivalency',
    rvcc: 'RVCC',
    square: 'National qualification',
    document: 'Document',
    news: 'News',
    contact: 'Contact',
  },
  language: {
    pt: 'Portuguese',
    en: 'Ingles',
  },
  homePage: {
    component_of: 'Component of',
    snq: 'National Qualification System',
    catalog: 'National Qualifications Catalog',
    catalog_ordinance: 'Ordinance no. 9/2020, February 20 ',
    equivalency: 'Equivalences',
    rvcc: 'RVCC Professional',
    rvcc_ordinance: 'Ordinance no. 10/2020, February 20 ',
    square: 'National Qualifications Framework',
    square_ordinance: 'Ordinance no. 10/2020, February 20 ',
    access_platform: 'Access the following platforms',
    access_platform_form_info: 'for more information',
    statics_start: 'Ours',
    statics_end: 'statistics',
    partners_start: 'Ours',
    partners_end: 'partners',
    faq_start: 'Frequent',
    faq_end: 'Asked Questions',
    about_us_start: 'What they say',
    about_us_end: 'About us',
    news_start: 'Last',
    news_end: 'News',
    platform: {
      name1: 'PAEF',
      name2: 'Carteira Profissional',
      name3: 'Request Equivalence',
      name4: 'Simulate Qualification',
    },
    simulate_qualification: {
      title_start: 'Simulate',
      title_end: 'Qualification',
      description:
        'This feature allows users to discover available qualifications based on their level of education, providing a direct visualization of accessible educational options.',
      label: {
        school_level: 'Level of education',
        training_level: 'Level of training',
      },
    },
    banner: {
      main_title1: 'National',
      main_title2: 'Qualification',
      main_title3: 'System',
      slogan: 'Promoting More Qualification and Better Employability',
      content:
        'Service responsible for promoting, developing and integrating technical and vocational training offers through the National Qualifications Catalog, enabling the assessment and certification of professional skills',
    },
  },
  catalogPage: {
    catalog_start: 'National Qualifications',
    catalog_end: 'Catalog',
    catalog_description:
      'The National Qualifications Catalog (CNQ) is a dynamic instrument for the strategic management of professional qualifications that integrates the National Qualifications System (Decree-Law No. 66/2010, of December 27).',
    filter: 'Search filter',
    searchResult: 'Result: {{number}} Qualification Founded.',
    level: 'Level',
    modules: '{{module}}  Modules  - {{hours}}  Hours',

    school_level: '**Prerequisites** - {{name}}',
    codes: '**Codes** - {{name}}',
    labels: {
      family: 'Family',
      qualification: 'Qualification',
      level: 'Level',
    },
  },
  catalogDetailsPage: {
    professional_profile_start: 'Professional',
    professional_profile_end: 'Profile',
    training_program_start: 'Training',
    training_program_end: 'Program',
    unit_skill_start: 'Units',
    unit_skill_end: 'Skills',
    unit_skill: 'Unit Skill',
    modules: 'Modules',
    codes: 'Codes',
    hours: 'Hours',
    document: 'Document',
    access_qualification_start: 'Access to ',
    access_qualification_end: 'Qualification',
    general_doc: 'General Documentation',
  },
  contactPage: {
    content_start: 'Get in',
    content_end: 'Touch',
    hour: 'Work Time',
    hour_content: 'Monday to Friday - 08:00 to 17:00',
    contact: 'Contact',
    contact_content: '+238 333 7076/7061/7059',
    pbx: 'PBX',
    pbx_content: '+238 333 7021/7055',
    address: 'Plateau - Former Banco de Cabo Verde (BCV) building, on the 6th floor',
    msg_content:
      'Please let us know if you have a question, want to leave a comment, or would like more information about the National Qualifications System.',
    msg: 'Message',
  },
  rvccPage: {
    content_start: 'Recognition, Validation and',
    content_end: 'Certification of Professional Skills (RVCC)',
    content:
      "Decree-Law no. 54/2014 of September 22 is the legal regime that regulates the System for the Recognition, Validation and Certification of Professional Skills acquired and developed throughout life, namely in a work context. RVCC is the formal process that allows individuals to obtain recognition, validation and certification of their professional skills acquired throughout life, regardless of how they were obtained. This process is aimed at individuals aged 25 or over with at least 5 years' professional experience. The recognition, validation and certification of professional skills is based on the professional skills references included in the National Qualifications Catalog (CNQ), in accordance with article 23 of Decree-Law 66/2010 of December 27. The National Qualifications System Coordination Unit (UC-SNQ) is the entity responsible for organizing and coordinating the system for the recognition, validation and certification of professional competences. The process of certifying professional competences is carried out by accredited entities, authorized for this purpose, with the support and supervision of the Directorate-General for Employment and the Coordination Unit of the National Qualifications System.",
    objective: {
      content_start: 'Main',
      content_end: 'objectives',
      content_1: 'To increase the level of professional qualification of young people and adults',
      content_2: 'Improve employability by encouraging lifelong learning',
    },
    documents: {
      content_start: 'Required',
      content_end: 'Documents',
      content_1:
        'Curriculum vitae to attest to the consistency of the professional experience of the candidate for the RVCC process;',
      content_2:
        'Statements from employers to confirm that they have been working for the minimum time required;',
      content_3:
        'Statements from employers confirming that they have been working for the minimum time required;',
      content_4:
        'Other means of proof deemed necessary by the entity responsible for developing the RVCC process.',
    },
    process: {
      content_start: 'Stages of the ',
      content_end: ' RVCC PROCESS',
      content:
        'This process consists of a set of methodological and certification steps and procedures that enable individuals to obtain recognition and certification of professional skills acquired in a non-formal or informal way',
      content_1: 'Information and guidance',
      content_2: 'Recognition',
      content_3: 'Validation',
      content_4: 'Skills Certification',
    },
    responsible: {
      content_start: 'Entities',
      content_end: 'RESPONSIBLE FOR RVCC',
      content: 'A number of organizations are part of the network of RVCC system operators:',
      content_1: 'General Directorate of Employment',
      content_2: 'National Qualifications System Coordination Unit (UC-SQN)',
      content_3: 'Public and private training providers, duly accredited',
      content_4: 'Technical schools',
    },
    access: {
      content_start: 'Access system',
      content_end: 'Fees',
      content: 'Fees payable to access the RVCC',
      content_1: 'Registration in the RVCC process: 5,000$00 (five thousand escudos)',
      content_2:
        'Participation in the professional skills certification process: 15,000$00 (fifteen thousand escudos)',
      content_3: 'Certification of professional skills: 8,000$00 (eight thousand escudos)',
      content_4: 'Issuing various documents: 1,000$00 (one thousand escudos)',
    },
  },
  squarePage: {
    content_start: 'National',
    content_end: 'Qualifications',
    content:
      'The QNQ is regulated by <span style="color:blue">Decree-Law No. 65/2010, of December 27th</span>, repealed by <span style="color:blue">Joint Order No. 10/2020, of February 20th</span>."',
    accordion: {
      what_is: {
        title: 'What is the National Qualifications Framework?',
        content_1:
          'The National Qualifications Framework (NQF) is a unique reference framework that classifies all qualifications produced within the scope of the national educational and training system, regardless of the access route, as defined in joint ordinance no. 10/2020, of February 20.',
        content_2:
          'The NQF is regulated by Decree-Law No. 65/2010, of December 27, repealed by Joint Ordinance No. 10/2020, of February 20.',
      },
      qualification_level: {
        title: 'What are qualification levels?',
        content:
          'They are indicators of the complexity and/or depth of knowledge, skills and attitudes (autonomy and responsibility) that an individual should be able to demonstrate at a given level of qualification.',
      },
      structure: {
        title: 'What is its structure?',
        description:
          'The NQF is structured into 8 qualification levels, each defined by a set of indicators that specify the learning outcomes corresponding to the qualifications at that level.',
        table: {
          h1: 'LEVELS',
          h2: 'KNOWLEDGE',
          h3: 'Skills',
          h4: 'AUTONOMY AND RESPONSIBILITIES',
          content: {
            level1: {
              level: 'Level 1',
              knowledge: 'Basic general knowledge.',
              skills: 'Basic skills needed to carry out simple tasks.',
              autonomy: 'Work or study under direct supervision in a structured context',
            },
            level2: {
              level: 'Level 2',
              knowledge: 'Conhecimentos factuais básicos numa área de trabalho ou de estudo.',
              skills:
                'Aptidões cognitivas e práticas básicas necessárias para a aplicação da informação adequada à realização de tarefas e à resolução de problemas correntes por meio de regras e instrumentos simples.',
              autonomy: 'Trabalhar ou estudar sob supervisão, com um certo grau de autonomia.',
            },
            level3: {
              level: 'Level 3',
              knowledge:
                'Conhecimentos de factos, princípios, processos e conceitos gerais numa área de estudo ou de trabalho.',
              skills:
                'Uma gama de aptidões cognitivas e práticas necessárias para a realização de tarefas e a resolução de problemas através da seleção e aplicação de métodos, instrumentos, materiais e informações básicas.',
              autonomy:
                'Assumir responsabilidades para executar tarefas numa área de estudo ou de trabalho. Adaptar o seu comportamento às circunstâncias para fins da resolução de problemas.',
            },
            level4: {
              level: 'Level 4',
              knowledge:
                'Conhecimentos factuais e teóricos em contextos alargados numa área de estudo ou de trabalho.',
              skills:
                'Uma gama de aptidões cognitivas e práticas necessárias para conceber soluções para problemas específicos numa área de estudo ou de trabalho.',
              autonomy:
                'Gerir a própria atividade no quadro das orientações estabelecidas em contextos de estudo ou de trabalho, geralmente previsíveis, mas suscetíveis de alteração. Supervisionar as atividades de rotina de terceiros, assumindo determinadas responsabilidades em matéria de avaliação e melhoria das atividades em contextos de estudo ou de trabalho.',
            },
            level5: {
              level: 'Level 5',
              knowledge:
                'Conhecimentos abrangentes, especializados, factuais e teóricos numa determinada área de estudo ou de trabalho e consciência dos limites desses conhecimentos.',
              skills:
                'Uma gama abrangente de aptidões cognitivas e práticas necessárias para conceber soluções criativas para problemas abstratos.',
              autonomy:
                'Gerir e supervisionar em contextos de estudo ou de trabalho sujeitos a alterações imprevisíveis. Rever e desenvolver o seu desempenho e o de terceiros.',
            },
            level6: {
              level: 'Level 6',
              knowledge:
                'Conhecimento aprofundado de uma determinada área de estudo ou de trabalho que implica uma compreensão crítica de teorias e princípios.',
              skills:
                'Aptidões avançadas que revelam a mestria e a inovação necessárias à resolução de problemas complexos e imprevisíveis numa área especializada de estudo ou de trabalho.',
              autonomy:
                'Gerir atividades ou projetos técnicos ou profissionais complexos, assumindo a responsabilidade da tomada de decisões em contextos de estudo ou de trabalho imprevisíveis. Assumir responsabilidades em matéria de gestão do desenvolvimento profissional individual e coletivo.',
            },
            level7: {
              level: 'Level 7',
              knowledge:
                'Conhecimentos altamente especializados, alguns dos quais se encontram na vanguarda do conhecimento numa determinada área de estudo ou de trabalho, que sustentam a capacidade de reflexão original e ou investigação. Consciência crítica das questões relativas aos conhecimentos numa área e nas interligações entre várias áreas.',
              skills:
                'Aptidões especializadas para a resolução de problemas em matéria de investigação e ou inovação, para desenvolver novos conhecimentos e procedimentos e integrar os conhecimentos de diferentes áreas.',
              autonomy:
                'Gerir e transformar contextos de estudo ou de trabalho complexos, imprevisíveis e que exigem abordagens estratégicas novas. Assumir responsabilidades por forma a contribuir para os conhecimentos e as práticas profissionais e/ou para rever o desempenho estratégico de equipas.',
            },
            level8: {
              level: 'Level 8',
              knowledge:
                'Conhecimentos de ponta na vanguarda de uma área de estudo ou de trabalho e na interligação entre áreas.',
              skills:
                'As aptidões e as técnicas mais avançadas e especializadas, incluindo capacidade de síntese e de avaliação, necessárias para a resolução de problemas críticos na área da investigação e/ou da inovação para o alargamento e a redefinição dos conhecimentos ou das práticas profissionais existentes.',
              autonomy:
                'Demonstrar um nível considerável de autoridade, inovação, autonomia, integridade científica ou profissional e assumir um firme compromisso no que diz respeito ao desenvolvimento de novas ideias ou novos processos na vanguarda de contextos de estudo ou de trabalho, inclusive em matéria de investigação.',
            },
          },
        },
      },
    },
  },
  newsPage: {
    content_start: 'Our ',
    content_end: 'HIGHLIGHTS',
    news: 'news',
  },
  documentPage: {
    content_start: 'General',
    content_end: 'Documentation',
    table: {
      title: 'Title',
      size: 'Size',
      action: 'Action',
    },
  },
  equivalencyPage: {
    content_start: 'National Commission for ',
    content_end: 'PROFESSIONAL EQUIVALENCES',
    content:
      'This specialized SNQ body, whose secretariat service has been provided by the SNQ Coordination Unit (UC-SNQ) since 2015, assesses and issues opinions on the awarding of Professional Equivalences to training courses or professional qualifications taken abroad or in foreign vocational training schools or entities based in Cape Verde.',
    cost: 'Cost',
    cost_value: '1000 ESCUDOS',
    account:
      ' Este valor será depositado na Conta Nº 30848162.10.004, em nome do Fundo de Promoção do Emprego e da Formação (FPEF), domiciliada na Caixa Económica de Cabo Verde.',
    submit: 'Submit Application',
    steppers: {
      personal_data: 'Person Information',
      academic_data: 'ACademic Details',
      attachments: 'Attachments',
      next: 'Next',
      back: 'Back',
      submit: 'Submit',
    },
    forms: {
      l_name: 'Full Name',
      l_address: 'Address',
      l_sex: 'Sex',
      l_nationality: 'Nationality',
      l_birth_date: 'Birth Date',
      l_email: 'Email Address',
      l_document_type: 'Document Type',
      l_document_number: 'Document Number',
      l_emission: 'Emission Local',
      l_telephone: 'Telephone',
      l_phone: 'Phone',
      l_course: 'Course',
      l_start_year: 'Start Year',
      l_end_year: 'End Year',
      l_country: 'Country',
      l_nif: 'NIF',
      l_requirement: 'Requirement',
      l_habilitation_certicate: 'Certificate Of Academic Qualifications',
      h_t_habilitation_certicate: 'Or school equivalence',
      l_course_certificate: 'Certificate',
      h_t_course_certificate: 'Or Professional Training Course Diploma',
      l_curriculum: 'Curriculum',
      h_t_curriculum: 'Or Professional Training Course History',
      l_document_tradoction: 'Certified Translation Of Documents Written In A Foreign Language',
      l_identification_document: 'Certified copy of ID card / Passport',
      l_proof_of_residence: 'Proof of residence permit',
      h_t_proof_of_residence: 'In The Case Of A Foreign National',
      l_proof_of_payment: 'Proof of Payment',
    },
    session_info: {
      who_can_request_title: 'Who can request?',
      who_can_request_content:
        'Any Cape Verdean citizen and foreigners holding professional qualifications obtained through a professional training system abroad or at a foreign school based in Cape Verde.',
      how_can_request_title: 'How to request?',
      how_can_request_content:
        'Online through the link …. or in person at UC-SNQ, located in Platô, Avenida Amilcar Cabral, former building of the Bank of Cape Verde, on the 6th floor.',
      clarification_contact: 'Contact for clarification',
      clarification_contact_content: 'Phone: +238 333 7055/7076/7061 or email: snqcv.uc@gmail.com',
      payment_fees: 'What fees to pay?',
      payment_fees_content1: 'Equivalence request, regardless of its granting: 1000$00.',
      payment_fees_content2: 'Certificate issuance: 2,500$00.',
      payment_fees_content3: 'Issuance of 2nd copy of the certificate: 1,300$00.',
      document_title: 'What documents are necessary?',
      document_content1:
        'a) Request addressed to the coordinator of the National Qualifications System;',
      document_content2: 'b) Copy of NIF declaration;',
      document_content3:
        'c) Authenticated copy of the certificate of academic qualifications or equivalence certificate;',
      document_content4:
        'd) Authenticated copy of the certificate or diploma of the professional training course;',
      document_content5:
        'e) Authenticated copy of the curriculum or transcript, with the respective workload per modules;',
      document_content6:
        'f) Authenticated translation into Portuguese of documents written in a foreign language;',
      document_content7: 'g) Authenticated photocopy of BI/CNI/Passport;',
      document_content8: 'h) Authenticated copy of residence permit (Foreigner);',
      document_content9:
        'i) Proof of payment made through DUC issued by the Employment and Training Promotion Fund (FPEF).',
      document_footer:
        'The original documents referred to in paragraphs c), d), e), and f) must be authenticated by the Embassy or Consulate of Cape Verde abroad, or, in their absence, by the government department responsible for foreign relations in Cape Verde.',
    },
  },

  snqPage: {
    about_start: 'About',
    about_end: 'SNQ',
    about_content:
      'The National Qualifications System of Cape Verde was created in 2010 through <span style="color:blue">Decree-Law No. 20/2010, of June 14</span>, amended by <span style="color:blue">Decree-Law No. 4/2018, of January 10</span>, which establishes the new legal framework regulating the matter.',
    scope_start: 'Our',
    scope_end: 'Scope',
    scope_content_1:
      "The National Qualifications System covers the instruments and actions needed to promote, develop and integrate technical and vocational training offers, through the National Qualifications Catalogue, enabling the assessment and certification of professional skills acquired throughout life, in order to encourage people's professional, human and social development and respond to the needs of the production system.",

    scope_content_2:
      'The main actions within the scope of the SNQ are developed through the development and implementation of Professional Qualifications Frameworks, specifically Competence Frameworks that reflect the Professional Profiles required in the labour market and Training Frameworks that correspond to the Training Programmes associated with these Profiles, with a view to responding to current and emerging market needs.',
    scope_content_3:
      "The SNQ's merit lies essentially in bringing together the efforts of various players in the education, training and employment sector, with the aim of improving the structure of Cape Verde's education and vocational training system, in terms of quality, for better employability.",
    scope_content_4:
      'The SNQ is run by the members of the Government responsible for the areas of Education, Vocational Training and Employment, through the central service in charge of coordinating professional qualification policies - the National Qualifications System Coordination Unit (UC-SNQ).',
    goal_start: 'Main',
    goal_end: 'OBJECTIVES',
    goals: {
      content_1: 'Promoting the integration of education, training and employment systems;',
      content_2:
        'Structuring standardised technical and vocational training offers, adjusted to the current and emerging needs of the labour market;',
      content_3:
        'Promover a igualdade de oportunidades no acesso às profissões, bem como à empregabilidade e ao desenvolvimento do empreendedorismo;',
      content_4:
        'Promoting the recognition of professional competences, including work and life experiences, acquired in various learning contexts;',
      content_5:
        'Encouraging rigour and objectivity in the analysis of vocational training diplomas/certificates obtained in foreign training systems.',
    },
    snq_component_start: 'Components of the',
    snq_component_end: 'NATIONAL QUALIFICATION SYSTEM',
    square_title: 'NATIONAL QUALIFICATIONS FRAMEWORK',
    square_content_1:
      'It is an instrument for classifying all the qualifications produced in the country, at the level of the different education subsystems, created with the publication of <span style="color:blue">Decree-Law no. 65/2010, of 27 December </span>, and currently regulated by <span style="color:blue">Joint Ordinance no. 10/2020, of 20 February</span>.',
    square_content_2:
      "The NQF is structured into eight (8) qualification levels, defined on the basis of three descriptors: Knowledge, Skills and Attitudes (KSA), with a view to enabling transparency and comparison with other countries' systems.",
    square_content_3:
      'It covers certificates and diplomas issued by the competent authorities in primary and secondary education, vocational training and higher education, as well as the certification of Professional Qualifications within the scope of the Professional Skills Recognition, Validation and Certification (Professional RVCC) process.',
    catalog_title: 'National Qualifications Catalogue (NQC)',
    catalog_content_1:
      'The National Qualifications Catalogue is one of the essential components of the National Qualifications System, created with the publication of <span style="color:blue">Decree-Law no. 66/2010, of 27 December </span>, and currently regulated by<span style="color:blue"> Joint Ordinance no. 9/2020, of 20 February</span>.',
    catalog_content_2:
      'It covers Professional Qualifications, based on competences and learning outcomes, organised by Professional Families.',
    catalog_content_3:
      'The NQC is a dynamic instrument for the strategic management of professional qualifications that are developed or updated on the basis of current and emerging market needs, essential factors for the competitiveness and modernisation of companies and the productive fabric, as well as for the human, personal and social development of the individual.',
    catalog_content_4:
      'The UC-SNQ is the service responsible for the development and permanent updating of the NQC, through the inclusion, exclusion or alteration of Professional Qualifications references.',
    catalog_content_5:
      'The Professional Qualifications Frameworks available on the NQC are drawn up and validated by Sectoral Technical Committees (CTS) and Sectoral Councils (COS), temporary bodies set up by the UC-SNQ to provide technical and advisory support in this process, under the terms of Article 9(2) of<span style="color:blue"> Decree-Law 7/2018 of 7 February </span>.',
    catalog_content_6:
      'Each Professional Qualification available on the NQC is identified by a Competency Framework (Professional Profile), a Training Framework (Training Programme) and a Qualification Level, awarded in accordance with the National Qualifications Framework (NQF).',
    catalog_content_7:
      'The National Qualifications Catalogue includes references for Professional Qualifications at Levels 2, 3, 4 and 5 of the NQF, organised by Professional Families and made available at national level.',
    catalog_content_8:
      'The NQC Professional Qualifications are reference instruments for Technical Education, Vocational Training and the process of Recognition, Validation and Certification of Professional Competences (RVCC Profissionais).',
    table: {
      title:
        'Requirements to access QP Courses offered at technical schools or accredited vocational training entities:',
      requirement_access: 'Entry requirement (Qualification required)',
      course: 'QP course, by NQF level',
      req_1: 'No requirements are demanded (as long as one can read and write).',
      access_1: 'QP Level 2 Course',
      req_2: '8th grade',
      access_2: 'QP Level 3 Course',
      req_3: '10th grade',
      access_3: 'QP Level 4 Course',
      req_4: '12th year of school',
      access_4: 'Level 5 QP course',
    },
  },
  ucsnqPage: {
    content_start: 'Coordination Unit',
    content_end: 'of the National Qualifications System (CU-NQS)',
    content:
      'Central government service responsible for coordinating, integrating, designing, implementing and providing technical support in the field of professional qualification policies.',
    mission: 'Mission',
    mission_content:
      'The mission of the UC-SNQ is to ensure the structuring of the National Qualifications System (NQS).',
    vision: 'Vision',
    vision_content:
      'Promote and develop the integration of training offers through the National Qualifications Catalogue (NQC)',
    direction: 'Management and institutional framework',
    direction_content_1:
      'The powers of direction over the UC-SNQ are exercised jointly and in articulation by the Ministry of Education (ME) and the Ministry of Finance and Business Development (MFFE), the members of the Government responsible for the Education, Training and Employment (EFE) sector, respectively.',
    direction_content_2:
      'The CU-NQS is headed by a Coordinator, under the terms of articles 10 et seq. of Decree-Law no. 7/2018, of 7 February, and is functionally part of the MFFE, the Government Department responsible for Vocational Training and Employment.',
    articulation: 'Institutional Articulation',
    articulation_content:
      'In order to guarantee the implementation of the policies, guidelines and plans defined in this field, the CU-NQS liaises with all the entities active in the Education, Training and Employment sector, specifically:',
    articulation_list_1:
      'Directorate-General for Employment (DGE), the central service responsible for technical and regulatory design and integration in the fields of Vocational Training, Employment and Entrepreneurship, as well as Professional Internships;',
    articulation_list_2:
      'The National Directorate of Education (DNE), the central service responsible for the education sector Technical Education Service and Youth and Adult Education (SETEJA);',
    articulation_list_3:
      'Employment and Vocational Training Institute (IEFP), and through it, the Employment and Vocational Training Centres (CEFP);',
    articulation_list_4: 'Economic and business players.',
    articulation_list_5: 'Social partners.',
  },

  footer: {
    address: 'Address',
    address_content: 'Plateau, Former BCV, 6th floor',
    phone: 'Phone',
    email: 'Email',
    followUs: 'Follow',
    home: 'Home',
    news: 'News',
    link: 'Links',
    contact: 'Contacts',
    entity: 'Training provider',
    accreditation: 'Accreditation Scheme',
    approval: 'Approval of certificates',
    coordination: 'COORDINATION UNIT',
    whatUCSNQ: 'What is UC-SNQ?',
    howWork: 'How does it work?',
    about_us: 'About SNQ',
    what_is: 'What is it?',
    snq_structure: 'SNQ structures',
    principles: 'Principles and Objectives',
    qualification_scheme: 'Qualifications Scheme',
    component: 'Components',
  },
};

export default en;
